export default "__VITE_ASSET__BzBR$cL8__"